import React from 'react';

const Pix: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.9014 1.28348C10.6127 -0.427826 13.3873 -0.427828 15.0986 1.28348L22.7165 8.9014C24.4278 10.6127 24.4278 13.3873 22.7165 15.0986L15.0986 22.7165C13.3873 24.4278 10.6127 24.4278 8.9014 22.7165L1.28348 15.0986C-0.427826 13.3873 -0.427828 10.6127 1.28348 8.9014L8.9014 1.28348ZM13.6844 2.69769C12.7541 1.76743 11.2459 1.76744 10.3156 2.6977L2.69769 10.3156C1.76743 11.2459 1.76744 12.7541 2.6977 13.6844L10.3156 21.3023C11.2459 22.2326 12.7541 22.2326 13.6844 21.3023L21.3023 13.6844C22.2326 12.7541 22.2326 11.2459 21.3023 10.3156L13.6844 2.69769Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.3999 5.5L6.69186 5.5C7.4768 5.5 8.23047 5.80764 8.7912 6.35693L11.3001 8.81464C11.6889 9.1955 12.3109 9.1955 12.6997 8.81464L15.2086 6.35692C15.7693 5.80764 16.523 5.5 17.3079 5.5L18.5999 5.5L18.5999 7.5L17.3079 7.5C17.0463 7.5 16.7951 7.60255 16.6082 7.78564L14.0992 10.2434C12.9329 11.3859 11.0669 11.3859 9.90057 10.2434L7.39164 7.78564L8.00779 7.15666L7.39164 7.78564C7.20473 7.60255 6.95351 7.5 6.69186 7.5L5.3999 7.5V5.5ZM12.6997 15.1854C12.3109 14.8045 11.6889 14.8045 11.3001 15.1854L8.7912 17.6431C8.23047 18.1924 7.4768 18.5 6.69186 18.5H5.3999V16.5H6.69186C6.95351 16.5 7.20473 16.3975 7.39164 16.2144L9.90056 13.7566C11.0669 12.6141 12.9329 12.6141 14.0992 13.7566L16.6082 16.2144C16.7951 16.3975 17.0463 16.5 17.3079 16.5H18.5999V18.5H17.3079C16.523 18.5 15.7693 18.1924 15.2086 17.6431L12.6997 15.1854Z"
      />
    </svg>
  );
};

export default Pix;
